import unauthorizedRedirect from "~/components/utilities/unauthorizedRedirect";

const removeForLoadedArticle = async function nextForSubmitArticle() {
  try {
    await this.$store.dispatch("updateSubmissionStatus", {
      action: "DELETE",
      params: {
        id: this.item.id,
      },
    });
  } catch (error) {
    if (
      error.status &&
      error.status.find((err) => err.message === "Access Denied")
    ) {
      unauthorizedRedirect(
        this.$router.replace,
        this.$isServer,
        this.$config,
        undefined
      );
    } else {
      throw error;
    }
  }

  this.$root.$emit("change-view", { view: "author-dashboard" });

  this.$store.dispatch("loadAuthorDashboard", {});
};

export default removeForLoadedArticle;
